const Reopen = () => {
    return (<svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.26898 7.53928H8.51864C9.12553 7.53928 9.70757 7.78037 10.1367 8.2095C10.5658 8.63864 10.8069 9.22067 10.8069 9.82756C10.8069 10.4345 10.5658 11.0165 10.1367 11.4456C9.70757 11.8748 9.12553 12.1158 8.51864 12.1158H7.53795M4.26898 7.53928L6.23036 5.57789M4.26898 7.53928L6.23036 9.50066M14.0759 3.18675V18L10.8069 16.6924L7.53795 18L4.26898 16.6924L1 18V3.18675C1 2.22087 1.70261 1.39361 2.66238 1.28202C5.90189 0.905992 9.17402 0.905992 12.4135 1.28202C13.3724 1.39361 14.0759 2.22087 14.0759 3.18675Z"
            // stroke="#4B5563"
            stroke="currentColor"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>)
}

export default Reopen;